<div id="content-section">
  <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
    <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <div class="text-center pagination-small-margin pagination-center">
        <pagination [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchParams.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div class="text-center pt-1">
        <app-pagination-count
          [count]="count"
          singularName="Part"
          pluralName="Parts"
        ></app-pagination-count>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="sticky-top bg-white">
        <h5 class="pt-2">
          <div class="pull-right float-right">
            <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
          </div>
          <span>
            Search&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
          </span>
        </h5>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-md-12" id="search-form" style="border-bottom: 1px solid #ccc">
          <div class="form-group mt-3">
            <label>Name</label>
            <input type="text" class="form-control" name="name" (keyup.enter)="search()" [(ngModel)]="searchParams.name" />
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="searchParams.is_global = !searchParams.is_global">
              <input [checked]="searchParams.is_global" type="checkbox" class="custom-control-input" [(ngModel)]="searchParams.is_global" />
              <label class="custom-control-label">Include global parts</label>
            </div>
          </div>
          <div class="form-group">
            <button (click)="searchParams.page = 1; search()" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
              Search
              <span *ngIf="searching">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">Document Template Parts</h2>
        <div class="py-4 text-center" *ngIf="loading">
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </div>
        <div class="py-4 text-center" *ngIf="loadingErred">
          <div class="alert alert-danger">Error loading page, try refreshing page, contact tech if issue persists</div>
        </div>
        <div class="table-responsive-md">
          <table class="table table-striped" *ngIf="count > 0">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Type</th>
                <th>Matter Type</th>
                <th class="text-center">Templates</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let docPart of docParts">
                <td>{{ docPart.id }}</td>
                <td>
                  {{ docPart.name }}
                  <span *ngIf="docPart.is_global || docPart.mandatory || docPart.expand_part">
                    <br />
                    <app-badge badgeType="secondary" *ngIf="docPart.is_global">Global</app-badge>
                    <app-badge badgeType="warning" *ngIf="docPart.mandatory">Mandatory</app-badge>
                    <app-badge badgeType="secondary" *ngIf="docPart.expand_part">Expand part</app-badge>
                  </span>
                </td>
                <td>{{ docPart.type }}</td>
                <td>{{ docPart.matter_type_name }}</td>
                <td class="text-center">{{ docPart.doc_templates_count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
